import { useEffect } from 'react';
import { withAllBranches } from '../../../../../../helpers/mappers';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useDishMenuStore } from '../../../../../../store/use-dish-menu-store';
import { getMenuId } from '../menu-informer-helpers';

export const useMenuInformerSlider = () => {
  const { getLocale, t, currentLang } = useLang();
  const { deleteMenu, isLoading, menuList, fetchMenuList, fetchMenu, setMenuListOrder } =
    useDishMenuStore();
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const menuId = getMenuId();
  const branchId = params.branchId;

  const { place, fetchBranches } = useBranchesStore();

  const branches = withAllBranches(place, currentLang);

  const createMenuModal = useModalParams('createMenu');
  const copyMenuModal = useModalParams('copyMenu');

  const filteredMenuList = branchId
    ? menuList?.filter((item) => Number(branchId) === item.place_id)
    : menuList;

  useEffect(() => {
    fetchMenuList({
      since_id: 0,
      n: 1000,
      is_by_company: true,
    });
  }, [fetchBranches, fetchMenuList]);

  useEffect(() => {
    if (!menuId) return;
    fetchMenu(menuId);
  }, [menuId]);

  const isRenderSlider = !!filteredMenuList?.length;

  return {
    getLocale,
    isLoading,
    menuList: filteredMenuList || [],
    createMenuModal,
    menuId,
    t,
    branches,
    copyMenuModal,
    isRenderSlider,
    deleteMenu,
    setMenuListOrder,
    addQueryParams,
  };
};
